const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  AUTH_TOKEN_EXPIRY_TIME: 'auth_token_expiry_time',
  USER_ID: 'user_id',
}

export const SESSION_STORAGE_KEYS = {}

export default STORAGE_KEYS
